module.exports = __webpack_public_path__ + "assets/ozon_100.ed1ea245ff23b17f015998d7816b89b2.png";